export const selectCandidateQuestions = ({ conditionalSurveys }) => conditionalSurveys.candidateQuestions;
export const selectSetConditionQuestions = ({ conditionalSurveys }) => conditionalSurveys.conditionQuestion;
export const selectUnLinkConditionQuestions = ({ conditionalSurveys }) => conditionalSurveys.unLinkCondition;
